export default __webpack_public_path__ + "static/media/trophy.6eecb66f.svg";